import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Section from 'help/common/Section'
import MainPage from 'help/common/MainPage'
import Article from 'help/common/Article'

export default class HelpInternal extends Component {
  constructor (props) {
    super(props)
    if (props.embedded && props.params.type && props.params.id) {
      this.state = {
        page: props.params.type,
        searchKey: props.params.id
      }
    } else {
      this.state = {
        page: 'main'
      }
    }
  }

  handleChangeView = (searchKey, page) => {
    this.setState({ searchKey: searchKey, page: page })
  }

  selectView = () => {
    if (this.state.page === 'sezione') {
      return <Section
        realm={this.props.realm}
        changeView={this.handleChangeView}
        onClickClose={this.props.close}
        searchKey={this.state.searchKey}
        embedded={this.props.embedded}
      />
    } else if (this.state.page === 'articolo') {
      return <Article
        realm={this.props.realm}
        changeView={this.handleChangeView}
        onClickClose={this.props.close}
        searchKey={this.state.searchKey}
        isInternal={this.props.isInternal}
        embedded={this.props.embedded}
      />
    } else {
      return <MainPage
        realm={this.props.realm}
        changeView={this.handleChangeView}
        onClickClose={this.props.close}
        embedded={this.props.embedded}
      />
    }
  }

  render () {
    return (
      this.props.loadData &&
      this.selectView()
    )
  }
}

HelpInternal.propTypes = {
  isInternal: PropTypes.bool,
  realm: PropTypes.string,
  close: PropTypes.func,
  loadData: PropTypes.bool,
  embedded: PropTypes.bool
}

HelpInternal.defaultProps = {
  isInternal: false,
  realm: 'fic',
  close: undefined,
  loadData: false,
  embedded: false
}



// WEBPACK FOOTER //
// ./src/help/internal/js/HelpInternal.js